module.exports = __webpack_public_path__ + "img/recource-folder-icon.c38f0232.svg";